import { useState, useEffect, useCallback } from 'react';
import { kitFetch } from '../utils/anonId.js';

export function useKit() {
  const [kit,setKit] = useState(null);
  const [loading,setLoading] = useState(true);
  const [saving,setSaving] = useState(false);
  const [error,setError] = useState(null);
  const apply = useCallback(d => setKit(d.kit || null),[]);
  useEffect(() => {
    let cancelled = false;
    const load = () => kitFetch('/kit').then(r => {
      if (!r.ok) throw Error('Could not load equipment profiles');
      return r.json();
    }).then(d => { if (!cancelled) apply(d); }).catch(e => {
      if (!cancelled) setError(e.message);
    }).finally(() => { if (!cancelled) setLoading(false); });
    load();
    window.addEventListener('og-kit-updated',load);
    return () => { cancelled = true; window.removeEventListener('og-kit-updated',load); };
  },[apply]);
  const saveKit = useCallback(async payload => {
    setSaving(true); setError(null);
    try {
      const r = await kitFetch('/kit',{method:'PUT',body:JSON.stringify(payload)});
      const d = await r.json();
      if (!r.ok) throw Error(d.error || 'Could not save equipment profiles');
      apply(d);
      window.dispatchEvent(new Event('og-kit-updated'));
      return d.kit;
    } catch(e) { setError(e.message); throw e; }
    finally { setSaving(false); }
  },[apply]);
  const profiles = kit?.profiles || (kit ? [{...kit,id:'legacy',name:kit.body || kit.scope || 'My equipment',
    setup_type:kit.body && kit.scope ? 'legacy' : kit.scope ? 'camera_telescope' : 'camera_lens',
    mount_type:kit.has_tracker ? 'equatorial' : 'fixed'}] : []);
  const activateKit = id => saveKit({profiles,active_profile_id:id});
  return {kit,profiles,activateKit,saveKit,loading,saving,error};
}
